import { Component, Input } from '@angular/core';

@Component({
  selector: 'sb-dropdown-select-item',
  templateUrl: './dropdown-select-item.component.html',
  styleUrls: ['./dropdown-select-item.component.scss'],
  standalone: false,
})
export class DropdownSelectItemComponent {
  @Input() icon?: string;
  @Input() label?: string;
  @Input() selected: boolean;
  @Input() isSingleSelect: boolean;

  constructor() {}
}
